export default {
    icons: {
        minimize: require("./images/icons/minimize.png"),
        restore: require("./images/icons/restore.png"),
        lockTip: require("./images/icons/lock.png"),
        commentsTip: require("./images/icons/comments.png"),
        d3View: require("./images/icons/3D_view.png"),
        iconView: require("./images/icons/icon_view.png"),
        cross: require("./images/icons/cross.svg"),
        magnifier: require("./images/icons/magnifier.svg"),
        moduleCorrupted: require("./images/icons/moduleCorrupted.png"),
        span: {
            on: require("./images/icons/span_on.svg"),
            off: require("./images/icons/span_off.svg")
        },
        selectMany: {
            on: require("./images/icons/selection_on.svg"),
            off: require("./images/icons/selection_off.svg")
        },
        pan: {
            on: require("./images/icons/pan_on.svg"),
            off: require("./images/icons/pan_off.svg")
        },
        pdf: {
            on: require("./images/icons/pdf_on.svg"),
            off: require("./images/icons/pdf_off.svg")
        },
        zoomIn: {
            on: require("./images/icons/zoom-in_on.svg"),
            off: require("./images/icons/zoom-in_off.svg")
        },
        zoomOut: {
            on: require("./images/icons/zoom-out_on.svg"),
            off: require("./images/icons/zoom-out_off.svg")
        },
        zoomExtent: {
            on: require("./images/icons/zoom-extent_on.svg"),
            off: require("./images/icons/zoom-extent_off.svg")
        },
        zoomSelection: {
            on: require("./images/icons/zoom-selection_on.svg"),
            off: require("./images/icons/zoom-selection_off.svg")
        },
        copy: {
            on: require("./images/icons/copy_on.svg"),
            off: require("./images/icons/copy_off.svg")
        },
        paste: {
            on: require("./images/icons/paste_on.svg"),
            off: require("./images/icons/paste_off.svg")
        },
        undo: {
            on: require("./images/icons/undo_on.svg"),
            off: require("./images/icons/undo_off.svg")
        },
        redo: {
            on: require("./images/icons/redo_on.svg"),
            off: require("./images/icons/redo_off.svg")
        },
        group: {
            on: require("./images/icons/group_on.svg"),
            off: require("./images/icons/group_off.svg")
        },
        ungroup: {
            on: require("./images/icons/ungroup_on.svg"),
            off: require("./images/icons/ungroup_off.svg")
        },
        magnet: {
            on: require("./images/icons/magnet_on.svg"),
            off: require("./images/icons/magnet_off.svg")
        },
        lock: {
            on: require("./images/icons/lock_on.svg"),
            off: require("./images/icons/lock_off.svg")
        },
        unlock: {
            on: require("./images/icons/unlock_on.svg"),
            off: require("./images/icons/unlock_off.svg")
        },
        free: {
            on: require("./images/icons/free_on.svg"),
            off: require("./images/icons/free_off.svg")
        },
        trash: {
            on: require("./images/icons/trash_on.svg"),
            off: require("./images/icons/trash_off.svg")
        },
        layers: {
            on: require("./images/icons/layers_on.svg"),
            off: require("./images/icons/layers_off.svg")
        },
        comments: {
            on: require("./images/icons/comments_on.svg"),
            off: require("./images/icons/comments_off.svg")
        },
        info: {
            on: require("./images/icons/info_on.svg"),
            off: require("./images/icons/info_off.svg")
        },
        favorites: {
            on: require("./images/icons/favorites_on.svg"),
            off: require("./images/icons/favorites_off.svg")
        },
        status: {
            in_progress: require("./images/icons/in_progress.png"),
            new: require("./images/icons/new.png")
        }
    }
};



// WEBPACK FOOTER //
// ./src/plano/images.js